import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { KindredMark } from "./KindredMark";
import { AmbientBackground } from "./AmbientBackground";

const PaymentCancelPage = () => {
  return (
    <div className="dark-landing relative flex min-h-screen items-center justify-center overflow-x-clip bg-obsidian px-6 text-cream" data-testid="payment-cancel-page">
      <AmbientBackground />
      <div className="relative z-[1] mx-auto max-w-lg py-24 text-center">
        <Link to="/" className="mb-12 inline-flex items-center gap-2.5" data-testid="payment-cancel-logo">
          <KindredMark className="h-8 w-8" />
          <span className="font-serif text-xl">Community Hearts</span>
        </Link>
        <XCircle className="mx-auto h-12 w-12 text-cream/40" data-testid="payment-cancel-icon" />
        <h1 className="mt-8 font-serif text-4xl leading-tight tracking-tight" data-testid="payment-cancel-headline">
          No charge <span className="italic text-gold">was made.</span>
        </h1>
        <p className="mx-auto mt-6 max-w-md text-base leading-relaxed text-cream/60">
          You left checkout before subscribing — nothing was charged and no membership was started. The founding member
          deal (50% off your first year) is still waiting whenever you're ready.
        </p>
        <Link
          to="/pricing"
          className="btn-glow mt-10 inline-block rounded-full bg-gold px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-ink hover:bg-gold-deep active:scale-95"
          data-testid="payment-cancel-home"
        >
          Back to pricing
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
